import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import ProgressOverview from '../MeineAusbildung/ProgressOverview'
import ItemsToCheck from '../../m/Uebersicht/ItemsToCheck'
import EmptyState from './UebersichtEmptyState'
import {routeHelper, routeKeys} from '#config/routeKeys'
import KachelListView from './KachelListView'
import {useNavigate} from "react-router-dom";

function AusbildungsnachweiseKachel({ausbildungsnachweiseModel, showAllItems, filterAbteilungen}) {
  if (!ausbildungsnachweiseModel) {
    return <FailedDataTile />
  }

  const {totalCount, items} = ausbildungsnachweiseModel

  const itemText = item => (
    <div>
      <span>{`${i18n.t('meineazubis_header_nachweistyp')} ${item.nummer}`}</span>
      <span>{`${item.lastname}, ${item.firstname}`}</span>
    </div>
  )

  const navigate = useNavigate()
  const handleClick = ({id}) => {
    navigate(routeHelper.ausbildungsnachweisDetail(id))
  }

  const redirect = () => navigate(routeKeys.uebersichtAusbildungsnachweise)

  const shollAllItemsButtonText = filterAbteilungen ? i18n.t('showMore') : i18n.t('showAll')

  return (
    <ProgressOverview titleKey="menu_item_ausbildungsnachweise" showProgressbar={false} testId="dashboard-nachweise">
      <ItemsToCheck itemText={i18n.t('uebersicht_ausbildungsnachweise')} itemValue={totalCount} />
      {totalCount === 0 ? (
        <EmptyState text={i18n.t('uebersicht_ausbildungsnachweise_empty')} />
      ) : (
        <KachelListView
          testId="kachellist-nachweise"
          items={items}
          showMoreButton={!showAllItems && totalCount > 5}
          itemText={itemText}
          handleClick={handleClick}
          showAllRedirect={redirect}
          showAllItemsButtonText={shollAllItemsButtonText}
        />
      )}
    </ProgressOverview>
  )
}

function FailedDataTile() {
  return (
    <ProgressOverview titleKey="menu_item_ausbildungsnachweise" showProgressbar={false} testId="dashboard-nachweise">
      <div data-testid="ausbildungsnachweiseNoData" className="ausbildungsnachweise">
        <span>{i18n.t('loading_dashboard_data_failed')}</span>
      </div>
    </ProgressOverview>
  )
}

AusbildungsnachweiseKachel.propTypes = {
  ausbildungsnachweiseModel: PropTypes.shape({
    totalCount: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        nummer: PropTypes.number,
        firstname: PropTypes.string,
        lastname: PropTypes.string,
      }),
    ).isRequired,
  }),
  showAllItems: PropTypes.bool.isRequired,
  filterAbteilungen: PropTypes.bool,
}

export default AusbildungsnachweiseKachel
